export enum EmploymentUserLogTypeEnum {
  SELF_SIGN_IN_AVAILABLE = 'SELF_SIGN_IN_AVAILABLE',
  INVITED = 'INVITED',
  INVITEE_AVAILABLE = 'INVITEE_AVAILABLE',
  INVITEE_UNAVAILABLE = 'INVITEE_UNAVAILABLE',
  SET_TO_AVAILABLE = 'SET_TO_AVAILABLE',
  SET_TO_UNAVAILABLE = 'SET_TO_UNAVAILABLE',
  DECLINED = 'DECLINED',
  CANCELLED = 'CANCELLED',
  BOOKED = 'BOOKED',
  POSSIBLE_CANDIDATE = 'POSSIBLE_CANDIDATE',
}
